import React, { useEffect, useState } from 'react';

const Toast = ({ message, type = 'success', onClose }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => { setVisible(false); onClose(); }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;
  return (
    <div className={`toast toast-${type} fade-in`}>
      {message}
      <style>{`
        .toast {
          position: fixed; bottom: 2rem; right: 2rem;
          padding: 1rem 1.5rem; border-radius: var(--radius-sm);
          color: white; font-weight: 500; z-index: 2000;
          box-shadow: var(--shadow-md);
        }
        .toast-success { background: var(--success); }
        .toast-error { background: var(--danger); }
        .toast-info { background: var(--primary); }
      `}</style>
    </div>
  );
};
export default Toast;